import { render, staticRenderFns } from "./MoveTabNavigation.vue?vue&type=template&id=6e453726&scoped=true"
import script from "./MoveTabNavigation.vue?vue&type=script&lang=js"
export * from "./MoveTabNavigation.vue?vue&type=script&lang=js"
import style0 from "./MoveTabNavigation.vue?vue&type=style&index=0&id=6e453726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e453726",
  null
  
)

export default component.exports